import { render, staticRenderFns } from "./LockerCompanyLogo.vue?vue&type=template&id=a4e6680c&"
import script from "./LockerCompanyLogo.vue?vue&type=script&lang=js&"
export * from "./LockerCompanyLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports